var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#serverIcon_svg__clip0_1497_9576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 4h.007M4 12h.007m-.54-5.333h9.066c.747 0 1.12 0 1.406-.146.25-.128.454-.332.582-.582.146-.286.146-.659.146-1.406V3.467c0-.747 0-1.12-.146-1.406a1.334 1.334 0 00-.582-.582c-.286-.146-.659-.146-1.406-.146H3.467c-.747 0-1.12 0-1.406.146-.25.127-.455.331-.582.582-.146.285-.146.659-.146 1.406v1.066c0 .747 0 1.12.146 1.406.127.25.331.454.582.582.285.146.659.146 1.406.146zm0 8h9.066c.747 0 1.12 0 1.406-.146.25-.128.454-.332.582-.582.146-.286.146-.659.146-1.406v-1.066c0-.747 0-1.12-.146-1.406a1.333 1.333 0 00-.582-.582c-.286-.146-.659-.146-1.406-.146H3.467c-.747 0-1.12 0-1.406.146-.25.127-.455.331-.582.582-.146.286-.146.659-.146 1.406v1.066c0 .747 0 1.12.146 1.406.127.25.331.454.582.582.285.146.659.146 1.406.146z",
    stroke: "#001529",
    strokeOpacity: 0.64,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "serverIcon_svg__clip0_1497_9576"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default SvgServerIcon;